// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"a5895aff","879":"27abedd1"}[chunkId] + ".chunk.js";
};